<template>
    <common-modal v-if="isOpen" height="smaill" @close="emitEvent({ name: 'close' })">
        <common-content-spacer height="medium">
            <div>
                <h2 class="head">
                    {{ $t('modals.patient_profile.profile.request.record_request.details_modal.req_details') }}
                    {{ $t('modals.patient_profile.profile.request.record_request.req') }}{{ request.id }}
                </h2>
                <div class="main-data-layout">
                    <div class="provider-detail">
                        <p>{{ $t('modals.patient_profile.profile.detail_form.detail_view.fields.provider') }}</p>
                        <span>{{ request.toProviderName }}</span>
                    </div>
                    <div class="provider-detail">
                        <p>{{ $t('modals.patient_profile.profile.detail_form.detail_view.fields.status') }}</p>
                        <span style="background: #eaf3fc; color: #3182ce; border-radius: 5px; padding: 2px 8px">
                            {{ request.status }}
                        </span>
                    </div>
                </div>
                <div class="provider-detail">
                    <p>{{ $t('modals.patient_profile.profile.request.record_request.details_modal.req_date') }}</p>
                    <span>{{ dateFormate(request.createdDateTime) }}</span>
                </div>
                <div class="provider-detail">
                    <p>{{ $t('modals.patient_profile.profile.request.record_request.details_modal.req_records') }}</p>
                    <span>{{ request.recordTypes?.join(', ') }}</span>
                </div>
                <div class="provider-detail">
                    <p>{{ $t('modals.patient_profile.profile.request.record_request.details_modal.hipaa_auth') }}</p>
                    <span>{{ request.hipaaFormId }}</span>
                </div>
                <div class="provider-detail">
                    <p>{{ $t('modals.patient_profile.profile.record_form.notes.name') }}</p>
                    <span>{{ request.notes }}</span>
                </div>
            </div>
        </common-content-spacer>
    </common-modal>
</template>

<script>
    import { dateFormate } from '~/helpers'

    export default {
        props: {
            request: { type: Object, required: true },
            isOpen: { type: Boolean, required: true },
        },
        data() {
            return {}
        },
        methods: {
            dateFormate,
            emitEvent(payload) {
                this.$emit(payload.name)
            },
        },
    }
</script>
<style scoped lang="scss">
    @import 'styles/setup/_variables.scss';
    @import 'styles/setup/_mixins.scss';
    .provider-detail p {
        font-size: 14px;
        font-weight: 500;
        color: $color-dark-2;
    }
    .provider-detail {
        margin-bottom: 20px;
        width: 360px;
    }
    .provider-detail span {
        font-size: 12px;
        font-weight: 400;
        color: $color-dark-2;
    }
    .main-data-layout {
        display: flex;
    }
    .head {
        margin-top: 0;
        margin-bottom: 16px;
        font-size: 16px;
        font-weight: 600;
        color: $color-dark-2;
    }
    .status-label {
        display: inline-block;
        background: #eaf3fc;
        color: #3182ce;
        border-radius: 12px;
        font-size: 14px;
        font-weight: 500;
        padding: 2px 12px;
        margin-left: 6px;
        vertical-align: middle;
    }
    .common-content-spacer {
        height: 24px;
    }
</style>
